<template>
<div 
  v-bind:class="[ showLabel ? 'col-lg-'+lg*col : '',showLabel ? 'col-md-'+md*col : '',showLabel ? 'col-sm-'+sm*col : '']">
  <div     
    v-if="showLabel"
    >
    <b-form-group
        :label="label"
        v-if="append"
      >  
      <b-input-group>
        <c-multiselect  
          :id="namePath+list+dataIndex[namePath]"
          :name="namePath+list+dataIndex[namePath]"
          placeholder="Buscar"
          v-model="searchSw.value"
          :options="filtrarOptions()"
          :filterCampos="'id|name|'+filterCampos"
          :customLabel="function (value) { return value.documento+' - '+value.name}"
          :allow-empty="false"
          :disabled="disabled"
          style="position: relative;flex: 1 1 auto;width: 1% !important;"
          @input="InputSelect($event)"
          @select="SelectSelect($event)"
          @remove="removeSelect($event)"
          @search-change="searchChangeSelect($event)"
          @tag="tagSelect($event)"
          @open="openSelect($event)"
          @close="closeSelect($event)">	
          <template v-slot:afterList v-if="showAgregar">
            <div class="text-center" style="border-top: 1px solid #dcdcdc">
              <button type="button" @click="agregar" class="btn btn-link btn-sm">Agregar <b-icon scale="1.4" icon="plus"></b-icon></button>
            </div>            
          </template>								 
        </c-multiselect> 
        <b-input-group-append>
          <b-button @click="appendFtn" variant="secondary" style="height: 31px;" size="sm">X</b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group> 
     <b-form-group
        :label="label"
        v-else
      >  
        <c-multiselect  
          :id="namePath+list+dataIndex[namePath]"
          :name="namePath+list+dataIndex[namePath]"
          placeholder="Buscar"
          v-model="searchSw.value"
          :options="filtrarOptions()"
          :filterCampos="'id|name|'+filterCampos"
          :customLabel="function (value) { return value.documento+' - '+value.name}"
          :allow-empty="false"
          :disabled="disabled"
          @input="InputSelect($event)"
          @select="SelectSelect($event)"
          @remove="removeSelect($event)"
          @search-change="searchChangeSelect($event)"
          @tag="tagSelect($event)"
          @open="openSelect($event)"
          @close="closeSelect($event)">	
          <template v-slot:afterList v-if="showAgregar">
            <div class="text-center" style="border-top: 1px solid #dcdcdc">
              <button type="button" @click="agregar" class="btn btn-link btn-sm">Agregar <b-icon scale="1.4" icon="plus"></b-icon></button>
            </div>            
          </template>								 
        </c-multiselect> 
    </b-form-group>   
  </div>
  <div v-if="showLabel===false">
        <c-multiselect  
          :id="namePath+list+dataIndex[namePath]"
          :name="namePath+list+dataIndex[namePath]"
          placeholder="Buscar"
          v-model="searchSw.value"
          :options="filtrarOptions()"
          :customLabel="function (value) { return value.documento+' - '+value.name}"
          :filterCampos="'id|name|'+filterCampos"
          label="name"
          :allow-empty="false"
          :disabled="disabled"
          @input="InputSelect($event)"
          @select="SelectSelect($event)"
          @remove="removeSelect($event)"
          @search-change="searchChangeSelect($event)"
          @tag="tagSelect($event)"
          @open="openSelect($event)"
          @close="closeSelect($event)">									 
        </c-multiselect> 
  </div>
  <b-modal 
    v-if="swModal"
    v-model="openModal.modal.value"
    :title="openModal.modal.title" 
    :header-bg-variant="openModal.modal.variant"
    header-text-variant="light"
    :hide-footer="true"  
    :no-close-on-backdrop="true" 
    :size="openModal.modal.size" 
    @hide="swModal=false" 
    >
      <slot name="modal"></slot>            
  </b-modal>    
</div>
</template>
<script>
import { mapState } from 'vuex'
import Multiselect  from '@/components/vue-multiselect/src/'
export default 
{
  name: 'swinputs',
  props: { 
    modalVariant: {
      type: String,
      default: 'primary'
    },  
    modalSize: {
      type: String,
      default: 'md'
    },  
    modalTitle: {
      type: String,
      default: 'Nuevo'
    },  
    filterCampos: {
      type: String,
      default: ''
    }, 
    label: {
      type: String,
      default: false
    },
    list: {
      type: String,
      default: false
    },
    sm : {
      type: Number,
      default: 12
    },
    md : {
      type: Number,
      default: 6
    },
    lg : {
      type: Number,
      default: 3
    },
    col: {
      type: Number,
      default: 1
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    showAgregar:  {
      type: Boolean,
      default: false
    },
    filter: {
      default: false
    },
    append: {
      default: false
    },
    disabled: {
      default: false
    }
  },
  data () 
  {
    return {
      swModal: false,
    }
  },
  components: {
    'c-multiselect': Multiselect,
  },
  methods: {
      filtrarOptions()
      {
        let list=this.lists[this.list]
        if(typeof this.filter === 'object')
        {
          if(this.filter.length>0)
          {
            return list.filter(items => { 
                let result = []
                for (let i=0;i<this.filter.length;i++)
                {
                  result.push(items[this.filter[i].campo].toString()===this.filter[i].value.toString())
                }
                return result.findIndex(list => list===false)===-1
              })
          }
          else 
          {
            return list.filter(items => { 
                return items[this.filter.campo].toString()===this.filter.value.toString() 
              })
          }
        }
        return list
      },
      InputSelect(event)
      {
        this.updateCrud({ state: 'swSearchs/'+this.list , data: this.lists[this.list].find(items => items.id === event) })
        this.$emit('input', {obj: event})
      },
      SelectSelect(event)
      {
        this.$emit('select',{obj: event})
      },
      removeSelect(event)
      {
        this.$emit('remove', {obj: event})
      },
      searchChangeSelect(event)
      {
        this.$emit('search-change', {obj: event})
      },
      appendFtn()
      {
        this.$emit('append', {obj: event})
      },
      tagSelect(event)
      {
        this.$emit('tag', {obj: event})
      },
      openSelect(event)
      {
        this.$emit('open', {obj: event})
      },
      closeSelect(event)
      {
        this.$emit('close', {obj: event})
      }, 
      async agregar()
      {   
        await this.resetDataIndex()
        await this.updateGlobal({state: 'openModal/modal/value',    data: true });
        await this.updateGlobal({state: 'openModal/modal/variant',  data: this.modalVariant});
        await this.updateGlobal({state: 'openModal/modal/title',    data: this.modalTitle});
        await this.updateGlobal({state: 'openModal/modal/size',     data: this.modalSize});
        this.swModal=true            
      }   
  }
}
</script>
<style>
  .form-group{
    margin: 10px 0;
  }
  .form-control {
    margin-bottom: 15px;
    width: 100% !important
  }
  .form-control:focus {
    -webkit-box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
    box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
  }
  .custom-select {
    width: 100% !important;
  }
  .custom-select:focus {
    -webkit-box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
    box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
  }
  .form-control.is-valid:focus{
    -webkit-box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
    box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
  }
  .form-control.is-invalid:focus{
    -webkit-box-shadow: 0 0 0 0.4px rgba(220, 53, 69, 0.25);
    box-shadow: 0 0 0 0.4px rgba(220, 53, 69, 0.25);
  }
  .custom-file-input.is-valid:focus ~ .custom-file-label {
    -webkit-box-shadow: 0 0 0 0.4px rgba(40, 167, 69, 0.25);
    box-shadow: 0 0 0 0.4px rgba(40, 167, 69, 0.25)
   }
  .custom-file-input.is-invalid:focus ~ .custom-file-label {    
    border-color: #dc3545;
    -webkit-box-shadow: 0 0 0 0.4px rgba(220, 53, 69, 0.25);
    box-shadow: 0 0 0 0.4px rgba(220, 53, 69, 0.25)
   }
   .form-control-readonly
   {
    background-color: #e9ecef;
    opacity: 1
   }
   .input-group .input-group-text {
     max-height: 31px;
   }
   .input-group span {   
    flex: 1 1 0%;
   }
   .input-errors {
     position: absolute;
     left: 0;
     bottom: 0;
     font-size: 12px;
     line-height: 12px;
   }
   .textarea-errors {
     position: absolute;
     left: 0;
     bottom: -18px;
     font-size: 12px;
     line-height: 12px;
   }
   .file-errors {
     position: absolute;
     left: 0;
     bottom: -21px;
     font-size: 12px;
     line-height: 12px;
   }
   .custom-file-input:focus ~ .custom-file-label {
     border-color: #80bdff;
    -webkit-box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
    box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
   }
   .custom-file.is-invalid .custom-file-label {
     border-color: #dc3545;
   }   
  .input-date {
    width: 100%;
    border: 1px solid #cecece;
    padding: 5px 2px;
    height: 30px;
    border-radius: 3px;
    background: white;
  }
  .input-date:focus{
     border-color: #80bdff;
    -webkit-box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
    box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
  }
  .input-date.is-invalid {
     border-color: #dc3545;
   } 
  .input-date:disabled{
    background-color: #e9ecef;
    opacity: 1;
   }   
   .multiselect{
     margin-bottom: 15px;
   }
   .multiselect__single{
     overflow: hidden
   }
       
</style>